/**
* 欢迎来到墨子工程
* 邮箱: duheng1100@163.com
* github: https://github.com/duheng/
**/
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var packages_header_nuxt = require('./packages/header/nuxt.js');
var normalizeComponent = require('./normalize-component-d885d5ff.js');
var base = require('./base-cc3cef3f.js');
var toString = require('./to-string-e5a81da9.js');
var packages_mqButton_index = require('./packages/mq-button/index.js');
require('./packages/lay-popup/index.js');
require('./packages/bf-dialog/index.js');
var packages_mqSearch_index = require('./packages/mq-search/index.js');
require('./packages/theme-select/index.js');
require('./packages/theme-select/themeBarMobile.js');
var packages_header_web = require('./packages/header/web.js');
require('./packages/mq-link/index.js');
var packages_mqTooltip_index = require('./packages/mq-tooltip/index.js');
var packages_mqChecked_index = require('./packages/mq-checked/index.js');
var packages_tradeInput_index = require('./packages/trade-input/index.js');
var index = require('./index-9e1f1547.js');
var index$1 = require('./index-5d056502.js');
var index$2 = require('./index-3faf9199.js');
var index$3 = require('./index-1651dbe5.js');
require('./vuex.esm-bundler-607ad4c2.js');
require('vue');
require('./regexp-exec-abstract-6e247220.js');
require('./themeContent-f8df7540.js');
require('./es.string.search-1012963e.js');
require('./es.number.constructor-17a0e7eb.js');

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`


var classList = normalizeComponent.documentCreateElement('span').classList;
var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;

var domTokenListPrototype = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;

var arrayMethodIsStrict = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && normalizeComponent.fails(function () {
    // eslint-disable-next-line no-useless-call -- required for testing
    method.call(null, argument || function () { return 1; }, 1);
  });
};

var $forEach = base.arrayIteration.forEach;


var STRICT_METHOD = arrayMethodIsStrict('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
var arrayForEach = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;

var handlePrototype = function (CollectionPrototype) {
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== arrayForEach) try {
    toString.createNonEnumerableProperty(CollectionPrototype, 'forEach', arrayForEach);
  } catch (error) {
    CollectionPrototype.forEach = arrayForEach;
  }
};

for (var COLLECTION_NAME in domIterables) {
  if (domIterables[COLLECTION_NAME]) {
    handlePrototype(normalizeComponent.global_1[COLLECTION_NAME] && normalizeComponent.global_1[COLLECTION_NAME].prototype);
  }
}

handlePrototype(domTokenListPrototype);

var components = [packages_mqButton_index, index.__vue_component__, index$1.__vue_component__, packages_mqSearch_index, index$2.__vue_component__, index$2.__vue_component__, packages_header_web, packages_header_nuxt, index$3.__vue_component__, packages_mqTooltip_index, packages_mqChecked_index, packages_tradeInput_index];
var install = function install(Vue) {
  components.forEach(function (component) {
    Vue.component(component.name, component);
  });
};

/* istanbul ignore if */
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

exports.HeaderNuxt = packages_header_nuxt;
exports.MqButton = packages_mqButton_index;
exports.MqSearch = packages_mqSearch_index;
exports.HeaderWeb = packages_header_web;
exports.MqTooltip = packages_mqTooltip_index;
exports.MqChecked = packages_mqChecked_index;
exports.TradeInput = packages_tradeInput_index;
exports.LayPopup = index.__vue_component__;
exports.BfDialog = index$1.__vue_component__;
exports.ThemeBarMobile = index$2.__vue_component__;
exports.ThemeSelect = index$2.__vue_component__;
exports.MqLink = index$3.__vue_component__;
